<template>
  <div class="personal">
    <Nav />
    <div style="height: 80px"></div>
    <div class="personal-bottom">
      <div class="personal-bottom-bottom">
        <div class="personal-bottom-bottom-left">
            <slide @change="changeSlide"></slide>
        </div>
        <div class="personal-bottom-bottom-right">
          <div class="personal-bottom-bottom-right-top">
            <div>我的位置：</div>
            <el-breadcrumb
              class="daohang"
              separator-class="el-icon-arrow-right"
            >
              <el-breadcrumb-item class="xinxi" :to="{ path: '/personalc?id=0&tab=0' }">
                <span>我的信息</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item
                class="xinxi"
              >
                <span>修改密码</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="personal-bottom-bottom-right-bottom">
            <div class="update_userinfoBox">
              <div class="item_input_name">
                <!-- <div style="color:#ffffff;width: 100px;height: 40px;line-height: 40px;margin-top:22px;">原密码</div> -->
                <div class="name">手机验证</div>
                <div class="phone_input">
                  <input
                    type="text"
                    placeholder="请输入手机号"
                    v-model="shoujihao"
                    oninput='this.value=this.value.replace(/\D/gi,"")'
                    maxlength="11"
                  />
                </div>

                <!-- <div style="color:#ffffff;width: 100px;height: 40px;line-height: 40px;margin-top:22px;">确定新密码</div> -->
              </div>
              <div class="item_input_name">
                <div class="name">验证码</div>
                <div class="phone_input">
                  <input
                    type="text"
                    placeholder="请输入验证码"
                    v-model="yanzhengma"
                     autocomplete="off"
                  />
                  <div
                    class="getCode"
                    :class="btnTitle !== '获取验证码' ? 'opct2' : ''"
                    @click="getCode"
                  >
                    <span class="btntxt">
                      {{ btnTitle }}
                    </span>
                  </div>
                  <!-- <button
                    class="home-button2"
                    v-show="botton1"
                    @click="Huoqu"
                  >
                  获取验证码
                </button> -->
                </div>
              </div>
              <div class="item_input_name">
                <div class="name">新密码</div>
                <div class="phone_input">
                  <input
                    ref="refpassword"
                    autocomplete="new-password"
                    type="password"
                    placeholder="请输入新密码"
                    v-model="password"
                    onkeyup="this.value=this.value.replace(/\s+/g,'')"
                  />
                </div>
              </div>
              <div @click="Tijiao" class="btn_next">提交</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="tishi1"
      style="
        position: absolute;
        top: calc(50% - 142px / 2);
        left: calc(50% - 248px / 2);
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      "
    >
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/cuowu2.png" alt="" />
      <div style="margin-top: 20px">手机号错误</div>
    </div>
    <div
      v-show="tishi2"
      style="
        position: absolute;
        top: calc(50% - 142px / 2);
        left: calc(50% - 248px / 2);
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      "
    >
      <img
        style="margin-top: 30px"
        src="https://oss.ansongqiubo.com/assets/personimage/tijiao.png"
        alt=""
      />
      <div style="margin-top: 20px">修改密码成功</div>
    </div>
    <div
      v-show="tishi3"
      style="
        position: absolute;
        top: calc(50% - 142px / 2);
        left: calc(50% - 248px / 2);
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      "
    >
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/cuowu2.png" alt="" />
      <div style="margin-top: 20px">{{ tishi }}</div>
    </div>
    <div
      v-show="tishi4"
      style="
        position: absolute;
        top: calc(50% - 142px / 2);
        left: calc(50% - 248px / 2);
        text-align: center;
        height: 142px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 1);
        width: 248px;
      "
    >
      <img style="margin-top: 30px" src="https://oss.ansongqiubo.com/assets/cuowu2.png" alt="" />
      <div style="margin-top: 20px">最小密码长度六位</div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import Nav from "../component/Nav.vue";
import slide from './template_slide.vue'
let timer = null
export default {
  name: "App",
  data() {
    return {
      b: 0,
      shoujihao: "",
      cooke: "",
      yanzhengma: "",
      password: "",
      btnTitle: "获取验证码",
      botton2: false,
      botton1: true,
      tishi1: false,
      tishi2: false,
      tishi3: false,
      tishi4: false,
      tishi: "",
      number: 0, //输入框长度
      activeName: 0,
    };
  },
  created() {
    this.cooke = localStorage.getItem("token");
    console.log(this.cooke);
  },
  methods: {
    changeSlide(data){
      this.$router.push(data);
    },
    getCode() {
      let reg = /^1[23456789]\d{9}$/;
      if (!reg.test(this.shoujihao)) {
        this.$message({
          message: "请输入正确的手机号",
          type: "warning",
        });
        return;
      }
      if (timer) {
        this.$message({
          message: "不能重复点击！",
          type: "warning",
        });
        return;
      }

      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/profile/passwordSmsCode",
        method: "post",
        data: {
          mobile: this.shoujihao,
        },
      }).then((res) => {
        if (res.data.message == "success") {
          this.$message({
            message: "验证码发送成功！",
            type: "success",
          });
          let time = 60;
          timer = setInterval(() => {
            if (time == 0) {
              clearInterval(timer);
              this.btnTitle = "获取验证码";
            } else {
              this.btnTitle = time + "s";
              time--;
            }
          }, 1000);
        }
      });
    },
    Huoqu() {
      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/profile/passwordSmsCode",
        method: "post",
        data: {
          mobile: this.shoujihao,
        },
      }).then((res) => {
        if (res.data.message == "success") {
          this.botton1 = false;
          this.botton2 = true;
          if (this.botton2 == true) {
            let time = 60;
            let timer = setInterval(() => {
              if (time == 0) {
                clearInterval(timer);
                this.botton1 = true;
                this.botton2 = false;
              } else {
                this.btnTitle = time + "s";
                this.disabled = true;
                time--;
              }
            }, 1000);
          }
        } else {
          this.tishi1 = true;
          setTimeout(() => {
            this.tishi1 = false;
          }, 2000);
        }
      });
    },
    dianji(e) {
      this.b = e;
    },
    Tijiao: function () {
      if(!this.yanzhengma){
          this.$message({
            message: "请输入验证码",
            type: "error",
          });
        return
      }
      let reg = /^1[23456789]\d{9}$/;
      if (!reg.test(this.shoujihao)) {
        this.$message({
          message: "请输入正确的手机号",
          type: "warning",
        });
        return;
      }
      if(!this.password){
          this.$message({
            message: "请输入新密码",
            type: "error",
          });
        return
      }
      if (this.number > 12) {
        this.tishi4 = true;
        setTimeout(() => {
          this.tishi4 = false;
        }, 2000);
      } else {
        this.$axios({
          headers: {
            device: "web",
            packageId: "1",
            version: "1.0.0",
            channel: "web",
            "authToken": this.cooke,
            "Content-Type": "application/x-www-form-urlencoded",
          },
          transformRequest: [
            function (data) {
              //在请求之前对data传参进行格式转换
              data = qs.stringify(data);
              console.log(data);
              return data;
            },
          ],
          url: this.api + "/v1/profile/password",
          method: "post",
          data: {
            password: this.password,
            token: this.yanzhengma,
          },
        }).then((res) => {
          console.log(res);
          if (res.data.message == "success") {
            this.tishi2 = true;
            setTimeout(() => {
              this.tishi2 = false;
              this.$router.push("/personalc");
            }, 2000);
          } else {
            this.tishi = res.data.message;
            this.tishi3 = true;
            setTimeout(() => {
              this.tishi3 = false;
            }, 2000);
          }
        });
      }
    },
  },
  watch: {
    password: {
      handler: function (e) {
        var _this = this;
        var _sum = 18; //字体限制为100个
        _this.$refs.refpassword.setAttribute("maxlength", _sum);
        _this.number = _sum - _this.$refs.refpassword.value.length;
        console.log(_this.number);
      },
      deep: true,
    },
  },
  components: {
    Nav,slide
  },
};
</script>
<style scoped lang='scss'>
.personal-bottom-bottom-left .el-collapse-item__header {
  box-sizing: border-box;
  padding-left: 20px;
  background-color: #fff;
  border-bottom: 0px solid #ebeef5;
  color: #333;
}
.personal-bottom-bottom-left .is-active {
  color: rgba(114, 30, 220, 1);
}
.personal-bottom-bottom-left .el-collapse-item__content {
  padding-bottom: 0px;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  border-bottom: 0px solid #ebeef5;
}
.personal-bottom-bottom-left .el-collapse-item__content > div {
  text-align: center;
}

.personal-bottom-bottom-left .el-collapse {
  border-top: 0px solid #ebeef5;
  width: 100%;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  /* background-color: black; */
  color: #333;
}

.personal {
  width: 100vw;
  background: #f7f8fa;
  .getCode {
    cursor: pointer;
    width: 114px;
    height: 36px;
    background: #721edc;
    border-radius: 4px;
    text-align: center;
    line-height: 36px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
  //   .getCodes {
  //   margin-left: 14px;

  //   cursor: pointer;
  //   width: 130px;
  //   height: 36px;
  //   background: #721edc;
  //   border-radius: 4px;
  //   text-align: center;
  //   line-height: 36px;
  //   .btntxt {
  //     font-size: 14px;
  //     font-family: PingFangSC-Regular, PingFang SC;
  //     font-weight: 400;
  //     color: #ffffff;
  //   }
  // }
  .xzcxzcxz {
    color: rgba(114, 30, 220, 1) !important;
  }
  .personal-bottom {
    background-color: #f7f8fa;
  }
  .personal-bottom-top {
    width: 100%;
    height: 60px;
    min-width: 1240px;
    background-color: #fff;
  }
  .personal-bottom-top-div {
    width: 1240px;
    height: 60px;
    margin: 0 auto;
    color: #333;
    font-size: 23px;
    line-height: 60px;
    display: flex;
    align-items: center;
  }
  .personal-bottom-top-div-div {
    width: 6px;
    height: 50px;
    background-color: #721edc;
    border-radius: 6px;
  }
}

.personal-bottom-bottom {
  width: 1200px;
  height: calc(100vh - 105px);
  margin: 0 auto;
  display: flex;
  background-color: #f7f8fa;
  min-width: 1200px;
  .personal-bottom-bottom-left {
    width: 190px;
    height: 100%;
    background-color: #fff;
    margin-top: 16px;
    color: #333;
    .myel-collapse-item {
      width: 190px;
    }
    .prent_item {
      text-align: center;
      width: 100%;
      height: 100%;
      display: flex;
      .parent_icon {
        display: flex;
        align-items: center;
      }
      .parent_name {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
    .child_item {
      color: #a6a6a6;
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #f2f2f2;
      .child_img {
        display: flex;
        align-items: center;
      }
      .child_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        cursor: pointer;
      }
    }
  }
}

.personal-bottom-bottom-right {
  flex: 2;
  margin-left: 12px;
  height: 100%;
  max-width: 998px;
  background-color: #fff;
  padding: 30px 20px;
  box-sizing: border-box;
  margin-top: 16px;
  .personal-bottom-bottom-right-top {
    background-color: #fff;
    display: flex;
    align-items: center;
  }
  .personal-bottom-bottom-right-top-left {
    width: 8px;
    height: 100%;
    background-color: #721edc;
  }
  .personal-bottom-bottom-right-top > span {
    color: white;
    margin-left: 20px;
    font-size: 24px;
  }
  .personal-bottom-bottom-right-bottom {
    height: calc(94% - 15px);
    margin-top: 15px;
    padding: 20px;
    position: relative;
    box-sizing: border-box;
  }
  .update_userinfoBox {
    display: flex;
    flex-direction: column;
    .btn_next {
      width: 130px;
      align-self: center;
      margin-top: 100px;
      user-select: none;
      cursor: pointer;
      height: 36px;
      background: #b3b3b3;
      border-radius: 4px;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
    .btn_next:hover{
        background:#721edc;
    }
    .item_input_name {
      margin-top: 16px;
      display: flex;
      align-items: center;
      .name {
        min-width: 86px;
        margin-right: 30px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }
      .phone_input {
        width: 260px;
        height: 36px;
        background: #f7f8fa;
        display: flex;
        border-radius: 4px;
        .home-button2 {
          cursor: pointer;
          border-radius: 0 6px 6px 0;
          background-color: rgba(114, 30, 220, 1);
          justify-content: center;
          align-items: center;
          font-size: 14px;
          outline: none;
          height: 36px;
          width: 80px;
          border: 0px;
          color: white;
          cursor: pointer;
        }
        input {
          box-sizing: border-box;
          outline-style: none;
          border: none;
          height: 36px;
          flex: 1;
          background: #f7f8fa;
          border-radius: 4px;
          padding: 0 10px;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
}

.daohang {
  display: flex;
  color: white;
  width: 500px;
}
.xinxi {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
.biao {
  width: 16px;
  height: 16px;
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
}
.colorBiao {
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
}
.a {
  background-color: #721edc;
}
.xzcxzcxz {
  color: white;
}
input {
  background: #464646;
  outline: none;
  border: 1px solid #464646;
}
input:focus {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/component/XiugaiPassword.vue